import { useUnit } from 'effector-react'
import { Button, Divider, Flex, Form, Input, Modal, Typography } from 'antd'
import { banClientFx } from 'src/pages/goldenMay2026/participants/model'


type Props = {
  id: string
  isVisible: boolean
  onClose: () => void
}
export const BanModal = ({ isVisible, onClose, id }: Props) => {
  const [form] = Form.useForm()
  const { Item } = Form
  const { Text } = Typography
  const { TextArea } = Input
  const loading = useUnit(banClientFx.pending)

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()

      await banClientFx({
        url: `/promo/golden_may_2026/participant/${id}`,
        body: { banReason: values.banReason },
      })

      form.resetFields()
      onClose()
    } catch (error) {
      console.log('error form validate', error)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Set disqualification reason</div>}
      centered
      wrapClassName="ant_modal"
      width={700}
      maskClosable={false}
      open={isVisible}
      destroyOnHidden
      onCancel={handleCancel}
      footer={
        <Flex gap={8} justify="flex-end">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            loading={loading}
            danger
            type="primary"
            onClick={handleSubmit}
          >
            Ok
          </Button>
        </Flex>
      }
    >
      <Divider />
      <Form form={form} layout="vertical">
        <Item
          required={false}
          name="banReason"
          label={
            <Text style={{ fontSize: 16 }} strong>
              Enter a reason
            </Text>
          }
          rules={[
            {
              required: true,
              message: 'Required field',
            },
          ]}
        >
          <TextArea rows={6} autoFocus placeholder="reason" />
        </Item>
      </Form>
      <Divider />
    </Modal>
  )
}
